// API Configuration
// In development: uses localhost:3001
// In production: uses same origin (backend serves frontend) OR custom API URL

const getApiUrl = () => {
  // If custom API URL is provided, use it (ensure it has protocol)
  if (process.env.REACT_APP_API_URL) {
    const url = process.env.REACT_APP_API_URL;
    // Add https:// if missing
    return url.startsWith('http') ? url : `https://${url}`;
  }

  // In production, use same origin (backend serves frontend)
  if (process.env.NODE_ENV === 'production') {
    return '';
  }

  // In development, use localhost backend
  return 'http://localhost:3001';
};

export const API_URL = getApiUrl();

export const API_ENDPOINTS = {
  subscribe: `${API_URL}/api/subscribe`,
  health: `${API_URL}/api/health`,
  generateWorkout: `${API_URL}/api/generate-workout`,
  addTag: `${API_URL}/api/add-tag`,
  checkEligibility: `${API_URL}/api/check-download-eligibility`,
  recordDownload: `${API_URL}/api/record-download`,
  upgradeTier: `${API_URL}/api/upgrade-tier`,
  verifyToken: `${API_URL}/api/verify-token`,
  savePendingUser: `${API_URL}/api/save-pending-user`,
};

